export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4616.c205367d.jpg";